import { SubjectManager } from "../util/subjectManager";

export const sharingInformationService = new SubjectManager();
